import {get,post} from '@/utils/request'

const SERVICE_URL = '/quotation-service/v1'

/** 询价 */
export function fetchQuotationList(params) {
    return post(SERVICE_URL + '/quotation/listQuotation', params)
}
/** 询价2 */
export function listQuotationBySupplierId(params) {
    return post(SERVICE_URL + '/quotation/listQuotationBySupplierId', params)
}

/** 零件清单 **/
export function getRfqPartsByVenderId(params) {
    return post(SERVICE_URL + '/quotation/getRfqPartsByVenderId', params)
}

/**保存报价**/
export function addPartPrice(params) {
    return post(SERVICE_URL + '/quotation/addPartPrice', params)
}
/**修改报价**/
export function editPartPrice(params) {
    return post(SERVICE_URL + '/quotation/editPartPrice', params)
}

/** 获取供应商 */
export function getSupplierByLoginUser(params) {
    return get(SERVICE_URL + '/quotation/getSupplierByLoginUser', params)
}
export function getRfqBaseById(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getRfqBaseById', params, pathParam)
}
export function getQuotationDetail(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getById', params, pathParam)
}
export function updateQuotationStatus(params, pathParam) {
    return get(SERVICE_URL + '/quotation/updateQuotationStatus', params, pathParam)
}
export function createQuotation(params) {
    return post(SERVICE_URL + '/quotation/insert', params)
}
export function editQuotation(params) {
    return post(SERVICE_URL + '/quotation/updateQuotation', params)
}
export function checkQuotation(params) {
    return post(SERVICE_URL + '/quotation/checkQuotation', params)
}
export function deleteQuotation(params, pathParam) {
    return get(SERVICE_URL + '/quotation/delete', params, pathParam)
}
//复制上一轮报价
export function copyPreviousQuotation(params) {
    return post(SERVICE_URL + '/quotation/copyPreviousQuotation', params)
}

// 外购零部件费
export function fetchRfqQuotationOutBuy(params) {
    return post(SERVICE_URL + '/quotation/getRfqPartOutBuy', params)
}
export function getRfqQuotationById(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getRfqPartOutBuyById', params, pathParam)
}
export function createRfqQuotationOutBuy(params) {
    return post(SERVICE_URL + '/quotation/insertRfqPartOutBuy', params)
}
export function createRfqQuotationOutBuyBatch(params) {
    return post(SERVICE_URL + '/quotation/insertRfqPartOutBuyBatch', params)
}
export function editRfqQuotationOutBuy(params) {
    return post(SERVICE_URL + '/quotation/updateRfqPartOutBuy', params)
}
export function removeRfqQuotationOutBuy(params, pathParam) {
    return get(SERVICE_URL + '/quotation/deleteRfqPartOutBuy', params, pathParam)
}

// 加工费换算
export function fetchRfqQuotationConversion(params) {
    return post(SERVICE_URL + '/quotation/getRfqConversionList', params)
}
export function getRfqQuotationConversionById(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getConversionById', params, pathParam)
}
export function createRfqQuotationConversion(params) {
    return post(SERVICE_URL + '/quotation/insertRfqConversion', params)
}
export function createRfqQuotationConversionBatch(params) {
    return post(SERVICE_URL + '/quotation/insertRfqConversionBatch', params)
}
export function editRfqQuotationConversion(params) {
    return post(SERVICE_URL + '/quotation/updateRfqConversion', params)
}
export function editRfqQuotationConversionBatch(params) {
    return post(SERVICE_URL + '/quotation/updateRfqConversionBatch', params)
}
export function removeRfqQuotationConversion(params, pathParam) {
    return get(SERVICE_URL + '/quotation/deleteRfqConversion', params, pathParam)
}

// 辅助材料
export function fetchRfqQuotationAuxiliaryMaterials(params) {
    return post(SERVICE_URL + '/quotation/getRfqPartProcessMaterialsList', params)
}

export function getRfqPartProcessMaterialsAll(params) {
    return post(SERVICE_URL + '/quotation/getRfqPartProcessMaterialsAll', params)
}

export function getRfqQuotationAuxiliaryMaterialsById(params, pathParam) {
    return get(SERVICE_URL + '/quotation/getRfqPartProcessMaterialsById', params, pathParam)
}
export function createRfqQuotationAuxiliaryMaterials(params) {
    return post(SERVICE_URL + '/quotation/insertRfqPartProcessMaterials', params)
}

export function createRfqQuotationAuxiliaryMaterialsBatch(params) {
    return post(SERVICE_URL + '/quotation/insertRfqPartProcessMaterialsBatch', params)
}

export function editRfqQuotationAuxiliaryMaterials(params) {
    return post(SERVICE_URL + '/quotation/updateRfqPartProcessMaterials', params)
}

export function editRfqQuotationAuxiliaryMaterialsBatch(params) {
    return post(SERVICE_URL + '/quotation/updateRfqPartProcessMaterialsBatch', params)
}

export function removeRfqQuotationAuxiliaryMaterials(params, pathParam) {
    return get(SERVICE_URL + '/quotation/deleteRfqPartProcessMaterials', params, pathParam)
}
/** 加工费管理 */
export function fetchProcessCostList(params) {
    return post(SERVICE_URL + '/processCost/list', params)
}
export function deleteProcessCost(params, pathParam) {
    return get(SERVICE_URL + '/processCost/deleteBatch', params, pathParam)
}
export function createProcessCost(params) {
    return post(SERVICE_URL + '/processCost/add', params)
}
export function createProcessCostBatch(params) {
    return post(SERVICE_URL + '/processCost/addBatch', params)
}
export function getProcessCostById(params, pathParam) {
    return get(SERVICE_URL + '/processCost/getById', params, pathParam)
}

export function editProcessCost(params) {
    return post(SERVICE_URL + '/processCost/edit', params)
}

export function editProcessCostBatch(params) {
    return post(SERVICE_URL + '/processCost/editBatch', params)
}

/** 模具、夹具、检具成本管理 */
export function fetchToolsCostList(params) {
    return post(SERVICE_URL + '/costOfTools/list', params)
}
export function deleteToolsCost(params) {
    console.log(params)
    return post(SERVICE_URL + '/costOfTools/deleteBatch', params)
}
export function createToolsCost(params) {
    return post(SERVICE_URL + '/costOfTools/add', params)
}
export function createToolsCostBatch(params) {
    return post(SERVICE_URL + '/costOfTools/addBatch', params)
}
export function getToolsCostById(params, pathParam) {
    return get(SERVICE_URL + '/costOfTools/getById', params, pathParam)
}

export function editToolsCost(params) {
    return post(SERVICE_URL + '/costOfTools/edit', params)
}
export function editToolsCostBatch(params) {
    return post(SERVICE_URL + '/costOfTools/editBatch', params)
}

/** 实验，设计管理 */
export function fetchDesignCostList(params) {
    return post(SERVICE_URL + '/costOfDesign/list', params)
}
export function deleteDesignCost(params) {
    return post(SERVICE_URL + '/costOfDesign/deleteBatch', params)
}
export function createDesignCost(params) {
    return post(SERVICE_URL + '/costOfDesign/add', params)
}
export function createDesignCostBatch(params) {
    return post(SERVICE_URL + '/costOfDesign/addBatch', params)
}
export function getDesignCostById(params, pathParam) {
    return get(SERVICE_URL + '/costOfDesign/getById', params, pathParam)
}

export function editDesignCost(params) {
    return post(SERVICE_URL + '/costOfDesign/edit', params)
}
export function editDesignCostBatch(params) {
    return post(SERVICE_URL + '/costOfDesign/editBatch', params)
}





//原材料
export function quotationMateralList(params) {
    return post(SERVICE_URL + '/rfqMaterialEntity/listPage', params)
}

export function quotationMateralInsert(params) {
    return post(SERVICE_URL + '/rfqMaterialEntity/insert', params)
}

export function quotationMateralInsertBatch(params) {
    return post(SERVICE_URL + '/rfqMaterialEntity/insertBatch', params)
}

export function quotationMateralUpdate(params) {
    return post(SERVICE_URL + '/rfqMaterialEntity/update', params)
}

export function quotationMateralUpdateBatch(params) {
    return post(SERVICE_URL + '/rfqMaterialEntity/updateBatch', params)
}

export function quotationMateralDelete(params, pathParam) {
    return get(SERVICE_URL + '/rfqMaterialEntity/delete', params, pathParam)
}

export function getQuotationMateralById(params, pathParam) {
    return get(SERVICE_URL + '/rfqMaterialEntity/getById', params, pathParam)
}

//包装运输费
export function boxGetByParam(params) {
    return post(SERVICE_URL + '/quotationBox/getByParams', params)
}

export function boxInsert(params) {
    return post(SERVICE_URL + '/quotationBox/insert', params)
}

export function boxUpdate(params) {
    return post(SERVICE_URL + '/quotationBox/update', params)
}

//包装箱成本明细
export function boxDetailList(params) {
    return post(SERVICE_URL + '/quotationBoxDetail/listPage', params)
}

export function boxDetailInsert(params) {
    return post(SERVICE_URL + '/quotationBoxDetail/insert', params)
}
export function boxDetailInsertBatch(params) {
    return post(SERVICE_URL + '/quotationBoxDetail/insertBatch', params)
}

export function boxDetailUpdate(params) {
    return post(SERVICE_URL + '/quotationBoxDetail/update', params)
}

export function boxDetailDelete(params, pathParam) {
    return get(SERVICE_URL + '/quotationBoxDetail/delete', params, pathParam)
}

export function boxDetailById(params, pathParam) {
    return get(SERVICE_URL + '/quotationBoxDetail/getById', params, pathParam)
}

// 导出询价函
export function exportRfq(params) {
    return post(SERVICE_URL + '/quotation/exportRfq', params)
}

// 导出价格确认书
export function exportConfirm(params) {
    return post(SERVICE_URL + '/quotation/exportConfirm', params)
}

// 根据零件信息查询出模具与实验设计信息
export function getToolsAndDesignByPart(params) {
    return post(SERVICE_URL + '/quotation/getToolsAndDesignByPart', params)
}

// 零件报价核算统计
export function getPartToatlPrice(params) {
    return post(SERVICE_URL + '/partView/getPartToatlPrice', params)
}
//导出零部件报价
export function exportPorts(params) {
    return post(SERVICE_URL + '/quotation/exportParts', params)
}

/** 供应商端报价表 **/
export function getSupplierRfqPartsByVenderId(params) {
    return post(SERVICE_URL + '/quotation/getSupplierRfqPartsByVenderId', params)
}

/** 供应商端最终报价时的报价表 **/
export function getSupplierLastRfqPartsByVenderId(params) {
    return post(SERVICE_URL + '/quotation/getSupplierLastRfqPartsByVenderId', params)
}
